import Vue from 'vue'
import Router from 'vue-router'
import Store from './stores'
import ls from 'localstorage-slim'
import CryptoJS from 'crypto-js'

import NotFound from './views/NotFound.vue'
import Login from './views/Login.vue'
import Page from './views/Page.vue'
import Coupon from './views/Coupon.vue'
import Cart from './views/Cart.vue'
import Amenity from './views/Amenity.vue'
import Product from './views/Product.vue'
import Reservation from './views/Reservation.vue'
import Mypage from './views/Mypage.vue'
import RoomCharge from './components/Mypage/RoomCharge.vue'
import Payment from './views/Payment.vue'
import SeparatePayment from './components/Payment/Separate.vue'
import ReservationList from './components/Mypage/ReservationList.vue'
import OrderList from './components/Mypage/OrderList.vue'
import PaymentList from './components/Mypage/PaymentList.vue'
import PaymentItem from './components/Mypage/PaymentItemPage.vue'
import PaymentReceipt from './components/Mypage/PaymentReceipt.vue'
import PaymentStep from './components/Payment/Step.vue'
import ReservationComplete from './components/Reservation/Complete.vue'
import CheckReservation from './components/Reservation/Check.vue'
import TvControl from './views/TvControl.vue'
import LocalInfo from './views/LocalInfo.vue'
import LocalView from './components/LocalInfo/LocalView.vue'
import LocalList from './components/LocalInfo/LocalList.vue'
import Control from './views/Control.vue'
import FlightInfo from './views/FlightInfo.vue'
import FlightSchedule from './components/FlightInfo/FlightSchedule.vue'
import Complete from './views/Complete.vue'
import ImageViewer from './components/Util/ImageViewer.vue'
import Checkout from './views/Checkout.vue'
import Morningcall from './views/Morningcall.vue'
import Parking from './views/Parking.vue'
import Mobility from './views/Mobility.vue'
import MyMobility from './components/Maps/My.vue'
import SuperAdmin from './views/SuperAdmin.vue'

ls.config.encrypt = true
ls.config.decrypt = true
ls.config.secret = 'istay-key-password'
ls.config.encrypter = (data, secret) => CryptoJS.AES.encrypt(JSON.stringify(data), secret).toString()
ls.config.decrypter = (data, secret) => {
  try {
    return JSON.parse(CryptoJS.AES.decrypt(data, secret).toString(CryptoJS.enc.Utf8))
  } catch (e) {
    // incorrect secret, return the encrypted data instead / or null
    return data // or return null;
  }
}

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: {
        name: 'main'
      }
    },
    {
      path: '/:ln/login',
      name: 'login',
      component: Login,
      props: true
    },
    {
      path: '/notfound',
      name: 'notfound',
      component: NotFound,
      props: true
    },
    {
      path: '/:ln/superadmin',
      name: 'superadmin',
      component: SuperAdmin,
      props: true
    },
    {
      path: '/:ln/complete',
      name: 'complete',
      component: Complete,
      props: true
    },
    {
      path: '/:ln',
      name: 'main',
      component: Page,
      props: true
    },
    {
      path: '/:ln/page/:id',
      name: 'page',
      component: Page,
      props: true
    },
    {
      path: '/:ln/coupon',
      name: 'coupon',
      component: Coupon,
      props: true
    },
    {
      path: '/:ln/cart',
      name: 'cart',
      component: Cart,
      props: true
    },
    {
      path: '/:ln/localinfo',
      name: 'localinfo',
      component: LocalInfo,
      meta: { translate: 'always' },
      props: true,
      children: [
        {
          path: ':type',
          name: 'filteredLocalinfo',
          component: LocalList,
          props: true
        },
        {
          path: ':type/:placeId',
          name: 'localview',
          component: LocalView,
          props: true
        }
      ]
    },
    {
      path: '/:ln/flightinfo',
      name: 'flightinfo',
      component: FlightInfo,
      meta: { translate: 'always' },
      props: true
    },
    {
      path: '/:ln/flightinfo/:airport/schedule',
      name: 'flightSchedule',
      component: FlightSchedule,
      meta: { translate: 'always' },
      props: true
    },
    {
      path: '/:ln/amenity',
      name: 'amenity',
      component: Amenity,
      props: true
    },
    {
      path: '/:ln/control',
      name: 'control',
      component: Control,
      props: true
    },
    {
      path: '/:ln/product/:productId',
      name: 'product',
      component: Product,
      props: true
    },
    {
      path: '/:ln/product/:productId/:category',
      name: 'productCategory',
      component: Product,
      props: true
    },
    {
      path: '/:ln/product/:productId/:detailId',
      name: 'productDetail',
      component: Product,
      props: true
    },
    {
      path: '/:ln/reservation/:reservationId',
      name: 'reservation',
      component: Reservation,
      props: true
    },
    {
      path: '/:ln/reservation/check/:reservationId',
      name: 'checkReservation',
      component: CheckReservation,
      props: true
    },
    {
      path: '/:ln/reservation/complete/:reservationId',
      name: 'reservationComplete',
      component: ReservationComplete,
      props: true
    },
    {
      path: '/:ln/mypage',
      name: 'mypage',
      component: Mypage,
      props: true
    },
    {
      path: '/:ln/roomCharge',
      name: 'roomCharge',
      component: RoomCharge,
      props: true
    },
    {
      path: '/:ln/payment',
      name: 'payment',
      component: Payment,
      props: true
    },
    {
      path: '/:ln/paymentstep',
      name: 'paymentStep',
      component: PaymentStep,
      props: true
    },
    {
      path: '/:ln/myOrder',
      name: 'myOrder',
      component: OrderList,
      props: true
    },
    {
      path: '/:ln/myReservation',
      name: 'myReservation',
      component: ReservationList,
      props: true
    },
    {
      path: '/:ln/myPayment',
      name: 'myPayment',
      component: PaymentList,
      props: true
    },
    {
      path: '/:ln/myPayment/:orderId',
      name: 'myPaymentItem',
      component: PaymentItem,
      props: true
    },
    {
      path: '/:ln/payment/separate/:pg/:pgid',
      name: 'separatePayment',
      component: SeparatePayment,
      props: true
    },
    {
      path: '/:ln/myPayment/receipt/:orderId',
      name: 'paymentReceipt',
      component: PaymentReceipt,
      props: true
    },
    {
      path: '/:ln/tv',
      name: 'tv',
      component: TvControl,
      props: true
    },
    {
      path: '/:ln/imageViewer/:src',
      name: 'imageViewer',
      component: ImageViewer,
      meta: { changeNav: true },
      props: true
    },
    {
      path: '/:ln/checkout',
      name: 'checkout',
      component: Checkout,
      props: true
    },
    {
      path: '/:ln/morningcall',
      name: 'morningcall',
      component: Morningcall,
      props: true
    },
    {
      path: '/:ln/parking',
      name: 'parking',
      component: Parking,
      props: true
    },
    {
      path: '/:ln/mobility',
      name: 'mobility',
      component: Mobility,
      props: true
    },
    {
      path: '/:ln/mobility/my',
      name: 'myMobility',
      component: MyMobility,
      props: true
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (savedPosition) {
          resolve({ x: 0, y: windowScrollY })
        } else {
          resolve({ x: 0, y: 0 })
        }
      }, 500)
    })
  }
})

export default router

let popState = false
window.onpopstate = function (e) {
  popState = true
}

const isAuth = async () => {
  const siteInfo = getUrlParams()
  const site = siteInfo.site
  // const otaKey = window.location.hostname !== 'localhost' && siteInfo.k
  const otaKey = siteInfo.k
  const isAuth = typeof (site) !== 'undefined' && site !== ''
  const updateParams = function () {
    const deleteParam = /lang|bkey|messenger|best|metakey|gv/ // 불필요한 파라미터
    siteInfo.otavalid = 'false'
    return Object.keys(siteInfo).filter(key => !deleteParam.test(key)).map(key => `${key}=${siteInfo[key]}`).join('&')
  }
  function getUrlParams () {
    const params = {}
    window.location.search.replace(/[#?&]+([^=&]+)=([^&]*)/gi, function (str, key, value) {
      params[key] = value
    })
    Store.dispatch('authentication/setAuthInfo', params)
    return params
  }
  if (otaKey) {
    Store.dispatch('authentication/validateOtaKey', otaKey).then((res) => {
      if (!res) {
        history.replaceState({}, null, `${location.origin}${location.pathname}?${updateParams()}${location.hash}`)
      }
    })
  }
  if (siteInfo.public && siteInfo.public === 'true') {
    await Store.dispatch('authentication/getOtaKey')
  }
  return isAuth
}

const clearPaymentParams = () => {
  const siteInfo = getUrlParams()
  const updateParams = function () {
    const deleteParam = /commerce|orderId|orderStatus|orderReason/ // 결제완료 페이지 이후 불필요한 파라미터
    return Object.keys(siteInfo).filter(key => !deleteParam.test(key)).map(key => `${key}=${siteInfo[key]}`).join('&')
  }
  function getUrlParams () {
    const params = {}
    window.location.search.replace(/[#?&]+([^=&]+)=([^&]*)/gi, function (str, key, value) {
      params[key] = value
    })
    return params
  }
  history.pushState({}, null, `${location.origin}${location.pathname}?${updateParams()}${location.hash}`)
}

let windowScrollY = 0
router.beforeEach(async (to, from, next) => {
  if (!popState) {
    windowScrollY = window.scrollY
  }
  popState = false
  if (to.name !== 'notfound') {
    if (isAuth()) {
      if (from && from.name) {
        clearPaymentParams()
        next()
      } else {
        next()
      }
    } else {
      alert('Invalid access has been detected.')
      next({
        name: 'notfound'
      })
    }
  } else {
    next()
  }
})
